import { render, staticRenderFns } from "./ProsList.vue?vue&type=template&id=5316ab02&scoped=true&"
import script from "./ProsList.vue?vue&type=script&lang=js&"
export * from "./ProsList.vue?vue&type=script&lang=js&"
import style0 from "./ProsList.vue?vue&type=style&index=0&id=5316ab02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316ab02",
  null
  
)

export default component.exports